import { useCallback } from "react";
import { useTranslation } from "react-i18next";

// English lives at the root ("/about"); other languages are prefixed ("/de/about").
// Keeping English unprefixed preserves all existing indexed URLs.
export const useLocalePath = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    return useCallback(
        (path) => {
            const clean = path.startsWith("/") ? path : `/${path}`;
            if (lang === "en") return clean;
            return clean === "/" ? `/${lang}` : `/${lang}${clean}`;
        },
        [lang],
    );
};
